<template>
  <div class="rwo no-gutters">
    <div class="col-12 d-flex justify-content-center">
      <div class="d-flex" style="width:1280px">123</div>
    </div>
  </div>
</template>
<script>
export default {

};
</script>
<style lang="scss">

</style>
